module.exports = __webpack_public_path__ + "img/page7img2.eef5f993.png";